<div
  fxFill
  [ngClass]="displaySpecialLogin ? 'BackgroundContainerSpecialLogin' : 'BackgroundContainer'"
  fxLayout="column"
  fxLayoutAlign="space-around center"
  fxLayoutGap="30px"
>
  <div class="container" fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="30px">
    <div class="divImage">
      <img
        [ngClass]="displaySpecialLogin ? 'logoImageSpecialLogin' : 'logoImage'"
        [src]="
          displaySpecialLogin
            ? 'assets/basys-core-authentication/images/EWE_powered_by_BARTHAUER_LOGO.svg'
            : 'assets/basys-core-authentication/images/BaSYS_LOGO_frame.svg'
        "
      />
    </div>
    <div fxLayout="column" fxLayoutAlign="space-around center" class="formContainer" id="divContentLogIn">
      <abc-authentication-login
        #abcLoginComponent
        (onNeedsPasswordChange)="needsPasswordChange = true"
        [errorClass]="displaySpecialLogin ? 'blueError' : 'greenError'"
        [specialLogin]="displaySpecialLogin ? true : false"
        [basysLogin]="true"
      >
      </abc-authentication-login>

      <barthauer-abc-management-users-user-settings
        *ngIf="needsPasswordChange"
        [allowUserNameChange]="false"
        (onPasswordChanged)="abcLoginComponent.rerouteLogin('')"
      >
      </barthauer-abc-management-users-user-settings>
    </div>
  </div>
</div>
